/**
 * Mostly Copilot generated (change whatever you like)
 * Dev-only profiler for getNodeProfileById: tracks call count, cache hit/miss counts,
 * and time spent per uncached getProfile call (inclusive of any child profile resolved
 * during that call, which children also record separately — nested time is
 * double-counted here, mirroring buildDesignerNodeProfiling).
 * Disabled by default so overhead is a single boolean check when off.
 * Enabled in console via designer/client/src/ui/DesignerProfiling.tsx
 * */

export interface GetNodeProfileByIdPerfStats {
  callCount: number;
  cacheHitCount: number;
  cacheMissCount: number;
  totalTimeMs: number;
  maxTimeMs: number;
  averageTimeMs: number;
}

class GetNodeProfileByIdProfiler {
  private enabled = false;
  private callCount = 0;
  private cacheHitCount = 0;
  private cacheMissCount = 0;
  private totalTimeMs = 0;
  private maxTimeMs = 0;

  enable() {
    this.enabled = true;
  }

  disable() {
    this.enabled = false;
  }

  isEnabled() {
    return this.enabled;
  }

  reset() {
    this.callCount = 0;
    this.cacheHitCount = 0;
    this.cacheMissCount = 0;
    this.totalTimeMs = 0;
    this.maxTimeMs = 0;
  }

  recordCacheHit() {
    if (!this.enabled) return;
    this.callCount += 1;
    this.cacheHitCount += 1;
  }

  recordCacheMiss(durationMs: number) {
    if (!this.enabled) return;
    this.callCount += 1;
    this.cacheMissCount += 1;
    this.totalTimeMs += durationMs;
    if (durationMs > this.maxTimeMs) this.maxTimeMs = durationMs;
  }

  getStats(): GetNodeProfileByIdPerfStats {
    return {
      callCount: this.callCount,
      cacheHitCount: this.cacheHitCount,
      cacheMissCount: this.cacheMissCount,
      totalTimeMs: this.totalTimeMs,
      maxTimeMs: this.maxTimeMs,
      averageTimeMs: this.cacheMissCount ? this.totalTimeMs / this.cacheMissCount : 0,
    };
  }
}

// Singleton instance
export const getNodeProfileByIdProfiler = new GetNodeProfileByIdProfiler();

// Public API
export const enableGetNodeProfileByIdProfiling = () => getNodeProfileByIdProfiler.enable();
export const disableGetNodeProfileByIdProfiling = () => getNodeProfileByIdProfiler.disable();
export const resetGetNodeProfileByIdPerfStats = () => getNodeProfileByIdProfiler.reset();
export const getGetNodeProfileByIdPerfStats = () => getNodeProfileByIdProfiler.getStats();
